// Authentication Pages
import AdminLogin from "../pages/admin/auth/login";
import FrontLogin from "../pages/auth/Login";
import OtpVerification from "../pages/auth/OtpVerification";
import ResetPassword from "../pages/auth/ResetPassword";
import ForgotPassword from "../pages/auth/ForgotPassword";
import AdminForgotPassword from "../pages/admin/auth/ForgotPassword";
import AcceptUser from "../pages/admin/reset-password/ResetPassword";
import Login from "../pages/auth/Login";
import { userRoutes } from "../pages/admin/modules/users/user.routes";
import { dashboardRoutes } from "../pages/admin/modules/dashboard/dashboard.routes";
import { faqRoutes } from "../pages/admin/modules/Faqs/FaqList/faqs.routes";
import { faqCategoryRoutes } from "../pages/admin/modules/Faqs/FaqCategory/faqCategory.routes";
import { planRoutes } from "../pages/admin/modules/Plan/plan.routes";
import { formRoutes } from "../pages/admin/modules/Forms/forms.routes";
import { editorRoutes } from "../pages/admin/modules/Editor/editor.routes";
import { profileRoutes } from "../pages/admin/modules/profile/profile.routes";
import { taxRoutes } from "../pages/admin/modules/Tax/tax.routes";
import { activityRoutes } from "../pages/admin/modules/Activity/activity.routes";
import { emailTemplateRoutes } from "../pages/admin/modules/EmailTemplate/emailTemplate.routes";
import { siteSettingsRoutes } from "../pages/admin/modules/site-settings/siteSettings.routes";
import { enquiryRoutes } from "../pages/admin/modules/Enquiry/enquiry.routes";
import { pageRoutes } from "../pages/admin/modules/Page/page.routes";

import { organizationRoutes } from "../pages/admin/modules/Organization/organization.routes";
import { paymentGetwayRoutes } from "../pages/admin/modules/PaymentGetway/paymentGetway.routes";
import { paymentRoutes } from "../pages/admin/modules/Payment/payment.routes";
import { testimonialRoutes } from "../pages/admin/modules/Testimonial/testimonial.routes";
import { howitworksRoutes } from "../pages/admin/modules/HowItWorks/howitworks.routes";

import { serviceRoutes } from "../pages/admin/modules/Services/ServiceList/service.routes";
import { serviceCategoryRoutes } from "../pages/admin/modules/Services/ServiceCategory/serviceCategory.routes";
import { serviceTagsRoutes } from "../pages/admin/modules/Services/ServiceTags/serviceTags.routes";
import { mediaRoutes } from "../pages/admin/modules/Media/media.routes";

import { jobCategoryRoutes } from "../pages/admin/modules/Jobs/JobCategory/jobCategory.routes";
import { jobTagsRoutes } from "../pages/admin/modules/Jobs/JobTags/jobTags.routes";
import { jobDepartmentRoutes } from "../pages/admin/modules/Jobs/JobDepartment/jobDepartment.routes";
import { jobsApplicationRoutes } from "../pages/admin/modules/Jobs/JobApplication/jobApplication.routes";
import { jobExperienceRoutes } from "../pages/admin/modules/Jobs/JobExperience/jobExperience.routes";
import { jobSalaryRangeRoutes } from "../pages/admin/modules/Jobs/JobSalaryRange/jobSalaryRange.routes";
import { jobSkillRoutes } from "../pages/admin/modules/Jobs/JobSkill/jobSkill.routes";
import { jobQualificationRoutes } from "../pages/admin/modules/Jobs/JobQualification/jobQualification.routes";
import { jobEnquiryRoutes } from "../pages/admin/modules/Jobs/JobEnquiry/jobEnquiry.routes";

import { jobsRoutes } from "../pages/admin/modules/Jobs/JobList/jobs.routes";

import { userDashboardRoutes } from "../pages/user/dashboard/dashboard.routes";
import { jobsListRoutes } from "../pages/user/Jobs/JobsList/jobsList.routes";
import { jobApplyRoutes } from "../pages/user/Jobs/JobApply/jobApply.routes";
import { formDetailsRoutes } from "../pages/admin/modules/Forms/FormDetails/formDetails.routes";
import DummyPage from "../pages/user/DummyPage";
import Home from "../pages/front/Home";

// Example Data ===============>
//  {
//     key:"uniqueKey",
//     path: "/login",
//     routeType: "auth"||"admin"||"user"||"adminNotAllow"||false,
//     component: component || React.lazy(() => import("../pages/auth/Login")),
//     layout: "auth"||"front"||"admin",
//     disabled:true||false,
//     title: "page title",
//     subRoute: [
//       {
//         key:"uniqueKey",
//         path: "manage",
//         routeType: "auth"||"admin"||"user"||"adminNotAllow"||false,
//         component: component || React.lazy(() => import("../pages/employees/Manage")),
//         layout: "auth"||false,
//         disabled:true||false,
//         title: "page title",
//       },
//     ],
//  }

export const authRoutes = (data) => [
  {
    path: "/login",
    title: "login",
    component: Login,
  },
  // {
  //   path: "/",
  //   title: "Home",
  //   component: DummyPage,
  // },
  {
    path: "/accept-user",
    title: "Accept User",
    component: AcceptUser,
  },
  {
    path: "/admin/signin",
    title: "Admin Login",
    component: AdminLogin,
    routeType: "auth",
  },
  {
    path: "/signin",
    title: "signin",
    component: FrontLogin,
    routeType: "auth",
  },
  {
    path: "/account-verification",
    title: "OTP Verification",
    component: OtpVerification,
    routeType: "auth",
  },
  {
    path: "/reset-password",
    title: "Reset Password",
    component: ResetPassword,
    routeType: "auth",
  },
  {
    path: "/forgot-password",
    title: "Forgot Password",
    component: ForgotPassword,
    routeType: "auth",
  },
  {
    path: "/admin/forgot-password",
    title: "Admin Forgot Password",
    component: AdminForgotPassword,
    routeType: "auth",
  },
];
export const frontRoutes = (data) => [
  {
    path: "/",
    title: "Home",
    component: Home,
    layout: "front",
  },
];
export const routerData = (data) => {
  return [
    ...authRoutes(data),
    ...frontRoutes(data),
    ...dashboardRoutes(data),
    ...userRoutes(data),
    ...mediaRoutes(data),

    ...jobsRoutes(data),
    ...organizationRoutes(data),
    ...jobsApplicationRoutes(data),
    ...jobCategoryRoutes(data),
    ...jobTagsRoutes(data),
    ...jobDepartmentRoutes(data),
    ...jobExperienceRoutes(data),
    ...jobSkillRoutes(data),
    ...jobSalaryRangeRoutes(data),
    ...jobQualificationRoutes(data),
    ...jobEnquiryRoutes(data),

    ...serviceRoutes(data),
    ...serviceCategoryRoutes(data),
    ...serviceTagsRoutes(data),
    ...faqRoutes(data),
    ...faqCategoryRoutes(data),
    ...testimonialRoutes(data),
    ...howitworksRoutes(data),
    ...planRoutes(data),
    ...formRoutes(data),
    ...formDetailsRoutes(data),
    ...editorRoutes(data),
    ...profileRoutes(data),
    ...taxRoutes(data),
    ...activityRoutes(data),
    ...emailTemplateRoutes(data),
    ...siteSettingsRoutes(data),
    ...enquiryRoutes(data),
    ...pageRoutes(data),

    ...organizationRoutes(data),
    ...paymentGetwayRoutes(data),
    ...paymentRoutes(data),
    ...userDashboardRoutes(data),
    ...jobsListRoutes(data),
    ...jobApplyRoutes(data),
  ];
};
